<template>
  <div
    class="container container-xl margin-xl-bottom margin-xl-top l:margin-2xl-top">
    <page-title-block text="ag.term.indexDisplayTitle" theme="lead-1">
      <template #tools>
        <form-input
          v-model="filters.title"
          style="flex: 50%"
          type="text"
          icon="magnify"
          :apply-minimal-width="false"
          placeholder="ag.term.filter.text.placeholder"
          :label="false"
          class="margin-remove max-width-300"></form-input>
        <form-input
          v-model="filters.CategoryId"
          v-bind="categoryFilterFieldProps"
          style="flex: 50%"
          class="margin-remove max-width-300"></form-input>

        <!--
        <form-input
          v-model="filters.type"
          style="flex: 50%"
          type="select"
          :apply-minimal-width="false"
          icon="sliders-alt-horizontal"
          placeholder="ag.article.blog.filter.type.placeholder"
          :list="[
            { value: 'all', label: 'ag.article.blog.filter.type.all' },
            { value: 'blog', label: 'ag.article.blog.filter.type.blog' },
            { value: 'newsFlash', label: 'ag.article.blog.filter.type.newsFlash' },
          ]"
          :label="false"
          class="margin-remove"></form-input>
        -->
      </template>
    </page-title-block>
    <div v-if="terms" class="terms">
      <div v-for="(term, index) in terms" class="term-wrapper">
        <term-main
          :term="term"
          class=""
          :class="{ 'bg-bg-4': index % 2 === 0, 'bg-alt-1': index % 2 !== 0 }"
          style="height: 100%"></term-main>
      </div>
    </div>

    <pagination
      v-model:pageSize="pagination.limit"
      v-model:currentPage="pagination.start"
      class="margin-2xl-top"
      :total-count="pagination.totalCount"></pagination>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { useStore } from "vuex";
import { computed } from "vue";
import PageTitleBlock from "@/client/applications/agaloola/components/base/frameworks/we/AgPageTitleBlock";
import TermMain from "@/client/applications/agaloola/components/items/term/Main";

export default {
  components: {
    PageTitleBlock,
    TermMain,
  },
  layout: "default",
  props: {
    title: {
      type: [Boolean, String],
      default: false,
    },
  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(
      props,
      useStore()
    );
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "ag.term.indexPageTitle",
  data: function () {
    let initialTitleValue = this.$route?.query?.title
      ? this.$route?.query?.title
      : undefined;
    let pagination = {
      start: 0,
      limit: 5,
      totalCount: 0,
    };
    return {
      categoryFilterFieldProps: {
        name: "CategoryId",
        type: "Select2",
        translateList: false,
        valueKey: "id",
        labelKey: "name",
        icon: "align-justify-alt",
        label: false,
        placeholder: "ag.term.filter.category.placeholder",
        itemComponent: "iconItem",
        asyncListSource: "entity/category",
        asyncListLive: false,
        textFilterAsSaffronListFilter: true,
        asyncDataTextFilterParamName: "name",
        multiple: false,
        asyncListData: {
          simplified: true,
          filters: {
            type: "term",
          },
        },
        validation: {},
      },
      terms: false,
      pagination: pagination,
      filters: {
        title: initialTitleValue,
      },
      asyncData: {
        terms: {
          target: "agaloola/term",
          data: {
            filters: computed(() => this.filters),
            pagination: computed(() => this.pagination),
            ordering: {
              key: "order",
              direction: "asc",
            },
          },
          options: {
            dataMutator(data) {
              pagination.totalCount = data.totalCount;
              return data.items;
            },
          },
        },
      },
    };
  },
  watch: {
    filters: {
      deep: true,
      handler(newVal) {
        this.pagination.start = 0;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.terms {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  grid-gap: var(--margin-xl);

  @media (max-width: 1024px) {
    max-width: 400px;
    margin-inline: auto;
    grid-template-columns: minmax(0, 1fr);
  }
}

.term {
  max-width: 100%;
}
</style>
